// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4477":"5f88ca0da7cae8e6","7579":"d688a0d1ac9417f8","8950":"b454dad70366d6b0"}[chunkId] + ".css";
};